import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { ActionNotificationTiggerForms } from '@core/enums/action-notification-trigger-forms.enum';
import { SelectionOption } from '@core/models';
import { TriggerGroupForm, TriggerOption } from '@core/models/action-item-templates/add-edit-action-item-notification.model';

@Component({
    selector: 'app-action-notification-triggers-form',
    templateUrl: './action-notification-triggers-form.component.html',
    styleUrl: './action-notification-triggers-form.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ActionNotificationTriggersFormComponent {
  static readonly componentName = 'ActionNotificationTriggersFormComponent';
  
  @Input() sysText: any;
  @Input() formGroup: FormGroup;
  @Input() triggerOptions: TriggerOption[];
  @Input() otherActionItemOptions: SelectionOption[];
  @Input() triggerFormArray: FormArray<FormGroup<TriggerGroupForm>>;
  @Input() formArrayName: ActionNotificationTiggerForms;
  @Output() emitAddTriggerFormGroup = new EventEmitter<{formArray: FormArray<FormGroup<TriggerGroupForm>>, options: TriggerOption[]}>();

  @ViewChild('addTriggerButton', { read: ElementRef }) private addTriggerButton: ElementRef<HTMLButtonElement>;

  public actionNotificationTriggerForms = ActionNotificationTiggerForms;

  public addTriggerFormGroup(formArray: FormArray<FormGroup<TriggerGroupForm>>, options: TriggerOption[]) {
    this.emitAddTriggerFormGroup.emit({formArray, options});
  }

  public removeTriggerFormGroup(formArray: FormArray<FormGroup<TriggerGroupForm>>, index: number): void {
    // the pressed button goes with its row
    this.addTriggerButton.nativeElement.focus();
    formArray.removeAt(index);
  }
}
